import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { GlobalVariables } from '../redux/firestoreGlobalVariables/reducer';

export const getGlobalVariables = async () => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: environment.GLOBAL_VARIABLES_URL,
  });

  return data.body.data as GlobalVariables;
};
